<!-- eslint-disable vue/no-deprecated-v-bind-sync -->
<template>
  <div class="medical-detail-cntainer">
    <TopBg title="免费试用" sub-title="填写表单，客服专访" :bg="topBg" />
    <div class="main-content page">
      <div class="section">
        <div class="title">素未谋面，却能心照不宣</div>
        <div class="rows-3">
          <contact-item title="联系电话" value="400-888-0120">
            <template #icon>
              <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
                <path
                  d="M27.8512 36.1465C22.5053 30.8041 17.3957 24.6148 19.8458 22.1682C23.3455 18.665 26.3964 16.5085 20.1936 8.78687C13.9905 1.06536 9.85289 6.99489 6.45771 10.3899C2.54615 14.3049 6.2519 28.8976 20.6761 43.3247C35.1005 57.7453 49.6967 61.4575 53.6114 57.5396C57.0065 54.1477 62.9327 50.0136 55.2147 43.8075C47.4964 37.601 45.3364 40.652 41.8331 44.1549C39.383 46.5949 33.1968 41.4889 27.8512 36.1465Z"
                  fill="#1CB3B8" />
                <mask id="path-2-outside-1_2152_4803" maskUnits="userSpaceOnUse" x="5.15656" y="1" width="57"
                  height="57" fill="black">
                  <rect fill="white" x="5.15656" y="1" width="57" height="57" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M20.0869 21.9285C20.2084 21.808 20.3291 21.689 20.4486 21.5711C23.6686 18.3963 26.0372 16.0609 20.1939 8.78687C15.5375 2.99053 12.0449 4.88671 9.15656 7.62873C9.798 9.69044 10.7443 11.7714 11.9997 13.7793C14.2223 17.3341 17.0747 20.1184 20.0869 21.9285ZM42.4997 43.4818C43.3391 44.5939 44.279 45.6794 45.3155 46.7202C48.9697 50.3896 53.1852 52.8604 57.1647 53.9565C59.4166 51.2456 60.4279 47.9991 55.2151 43.8075C47.9972 38.0033 45.6402 40.2953 42.4997 43.4818Z" />
                </mask>
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M20.0869 21.9285C20.2084 21.808 20.3291 21.689 20.4486 21.5711C23.6686 18.3963 26.0372 16.0609 20.1939 8.78687C15.5375 2.99053 12.0449 4.88671 9.15656 7.62873C9.798 9.69044 10.7443 11.7714 11.9997 13.7793C14.2223 17.3341 17.0747 20.1184 20.0869 21.9285ZM42.4997 43.4818C43.3391 44.5939 44.279 45.6794 45.3155 46.7202C48.9697 50.3896 53.1852 52.8604 57.1647 53.9565C59.4166 51.2456 60.4279 47.9991 55.2151 43.8075C47.9972 38.0033 45.6402 40.2953 42.4997 43.4818Z"
                  fill="#386FC6" />
                <path
                  d="M20.0869 21.9285L18.5416 24.4999L20.5419 25.7019L22.1991 24.0589L20.0869 21.9285ZM20.4486 21.5711L18.3423 19.4349L20.4486 21.5711ZM20.1939 8.78687L22.5328 6.90808L22.5327 6.90801L20.1939 8.78687ZM9.15656 7.62873L7.09106 5.45301L5.73757 6.73794L6.29199 8.51995L9.15656 7.62873ZM11.9997 13.7793L14.5435 12.1889L14.5435 12.1889L11.9997 13.7793ZM42.4997 43.4818L40.3631 41.3759L38.5445 43.2211L40.1052 45.289L42.4997 43.4818ZM45.3155 46.7202L43.1898 48.8372V48.8372L45.3155 46.7202ZM57.1647 53.9565L56.3681 56.8488L58.2351 57.3631L59.4725 55.8734L57.1647 53.9565ZM55.2151 43.8075L53.3352 46.1454L53.3352 46.1454L55.2151 43.8075ZM22.1991 24.0589C22.3172 23.9418 22.4349 23.8256 22.555 23.7073L18.3423 19.4349C18.2233 19.5523 18.0996 19.6742 17.9746 19.7981L22.1991 24.0589ZM22.555 23.7073C23.9653 22.3167 26.2595 20.2187 26.6911 17.1316C27.1376 13.9376 25.5539 10.6689 22.5328 6.90808L17.8551 10.6657C20.6773 14.1788 20.8308 15.7148 20.7489 16.3008C20.652 16.9936 20.1519 17.6507 18.3423 19.4349L22.555 23.7073ZM22.5327 6.90801C19.9198 3.65545 17.0523 1.84763 13.86 2.00978C10.8867 2.16081 8.60282 4.01783 7.09106 5.45301L11.2221 9.80444C12.5986 8.49761 13.5052 8.03553 14.1644 8.00205C14.6046 7.97969 15.8116 8.12195 17.8552 10.6657L22.5327 6.90801ZM6.29199 8.51995C7.01142 10.8323 8.06679 13.1477 9.45598 15.3697L14.5435 12.1889C13.4219 10.395 12.5846 8.54856 12.0211 6.7375L6.29199 8.51995ZM9.45598 15.3697C11.9104 19.2953 15.0943 22.4283 18.5416 24.4999L21.6321 19.357C19.0551 17.8084 16.5342 15.3729 14.5435 12.1889L9.45598 15.3697ZM40.1052 45.289C41.0275 46.5111 42.0574 47.7001 43.1898 48.8372L47.4412 44.6033C46.5006 43.6588 45.6506 42.6766 44.8943 41.6745L40.1052 45.289ZM43.1898 48.8372C47.1657 52.8296 51.8259 55.5978 56.3681 56.8488L57.9614 51.0642C54.5445 50.1231 50.7737 47.9496 47.4412 44.6033L43.1898 48.8372ZM59.4725 55.8734C60.7745 54.3059 62.1799 52.056 61.9818 49.2276C61.7814 46.367 60.0131 43.816 57.0951 41.4696L53.3352 46.1454C55.6299 47.9906 55.9623 49.1587 55.9965 49.6469C56.0329 50.1674 55.8068 50.8962 54.857 52.0396L59.4725 55.8734ZM57.0951 41.4696C53.3622 38.4679 50.1143 36.8843 46.9403 37.2984C43.8494 37.7016 41.7558 39.9628 40.3631 41.3759L44.6364 45.5876C46.3841 43.8143 47.0393 43.3363 47.7164 43.2479C48.3105 43.1704 49.8501 43.3429 53.3352 46.1454L57.0951 41.4696Z"
                  fill="#F6F8FD" mask="url(#path-2-outside-1_2152_4803)" />
              </svg>
            </template>
          </contact-item>
          <contact-item title="售后QQ" value="1341686309">
            <template #icon>
              <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
                <circle cx="32" cy="23" r="15" fill="#1CB3B8" />
                <path
                  d="M54.4622 48.1133C53.2585 48.4383 52.2414 46.8786 51.0207 44.5458C50.1298 46.879 48.8116 49.0232 47.1344 50.8671C49.9357 52.6688 51.5023 55.2094 50.8943 57.4886C50.0276 60.7388 45.2261 61.3717 39.8188 60.8141C36.8092 60.5033 34.3226 59.2786 32.9129 57.5033C32.6507 57.5139 32.388 57.5204 32.1235 57.5204C31.8145 57.5204 31.5073 57.5122 31.2018 57.4986C29.795 59.2792 27.3079 60.5086 24.2953 60.8194C18.8945 61.377 14.0976 60.7441 13.2315 57.4933C12.6083 55.1517 14.2749 52.5351 17.2161 50.7257C15.4789 48.7154 14.1606 46.3746 13.3392 43.8421C11.9535 46.5488 10.8585 48.4565 9.53775 48.1009C7.53169 47.5598 7.61128 42.9666 9.06667 37.5014C10.0744 33.7172 12.0998 30.7085 13.9162 29.3949C13.9185 29.3142 13.9203 29.2342 13.9238 29.1529C13.9929 27.4366 14.636 25.8498 15.7379 24.4473V21.604C15.7379 12.4341 23.1266 5 32.2405 5C41.3544 5 48.7431 12.4341 48.7431 21.604V24.1988C50.0247 25.6832 50.7743 27.3659 50.8498 29.1529C50.8615 29.4373 50.8709 29.7184 50.8779 29.9961C50.8908 30.0285 50.9025 30.0608 50.9154 30.0932C52.4878 31.6264 54.0778 34.2843 54.9333 37.502C56.3887 42.9737 56.4683 47.5722 54.4622 48.1133Z"
                  fill="#1CB3B8" />
                <ellipse cx="32" cy="21.5" rx="17" ry="16.5" fill="#386FC6" />
                <path
                  d="M13.5 30.0015C12.7 28.4015 14.5 24.5006 15.5 25.0011C17.1667 27.6679 21.8 33.5015 33 33.5015C47 33.5015 48 24.5008 49 24.0008C50 23.5008 51.5 29.0022 51 30.0022C50.5 31.0022 47.5 39.0015 33 39.0015C30.7583 39.0015 28.7675 38.8342 27 38.5439L27 45.0014C27 47.5014 25.5 48.0014 22 47.5014C18.5 47.0014 18 44.0014 18.5 42.0014C18.8926 40.431 19.4779 37.1269 19.4994 36.0595C15.6085 33.8948 14.0689 31.1392 13.5 30.0015Z"
                  fill="#F6F8FD" />
              </svg>
            </template>
          </contact-item>
          <contact-item title="服务邮箱" value="service@zxstech.com">
            <template #icon>
              <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
                <path
                  d="M8.80067 10H55.1993C58.3646 10 60.9598 12.4967 61 15.5563L32.0101 31.2715L3.02682 15.5762C3.05365 12.5033 5.62874 10 8.80067 10ZM3.02682 21.5894L3 49.3775C3 52.4702 5.60863 55 8.80067 55H55.1993C58.3914 55 61 52.4702 61 49.3775V21.5762L32.6941 36.5563C32.2582 36.7881 31.7351 36.7881 31.3059 36.5563L3.02682 21.5894Z"
                  fill="#1CB3B8" />
                <path
                  d="M8.77652 10H55.1966C58.3633 10 60.9597 12.5822 61 15.7466L31.9966 32L3 15.7671C3.02684 12.589 5.60312 10 8.77652 10Z"
                  fill="#386FC6" />
              </svg>
            </template>
          </contact-item>
        </div>
      </div>
      <div class="map-section">
        <div class="left">
          <div class="left2">
            <div id="map"></div>
          </div>
        </div>
        <div class="right">
          <form-input :data.sync="form.name" label="姓名"></form-input>
          <form-input :data.sync="form.companyName" label="单位"></form-input>
          <form-input :data.sync="form.phone" label="电话 "></form-input>
          <form-input :data.sync="form.subMessage" label="需求" type="area" :rows="12"></form-input>
          <div @click="submit">
            <read-more class="read-more" width="100%" text="提交信息"></read-more>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TopBg from "../common/TopBg.vue";
import ContactItem from "../common/contact-item.vue";
import FormInput from "../common/form-input.vue";
import { addDemand } from "@/api";
import AMapLoader from "@amap/amap-jsapi-loader";

export default {
  name: "Free",
  components: {
    TopBg,
    ContactItem,
    FormInput,
  },
  data() {
    return {
      topBg: require("../../assets/freeBg.png"),
      marker: require("../../assets/marker.png"),
      form: {
        name: undefined,
        companyName: undefined,
        phone: undefined,
        subMessage: undefined,
      },
    };
  },
  created() {
    this.initMap();
  },
  methods: {
    submit() {
      if (!this.form.name || !this.form.phone) {
        this.$message({
          message: "请填姓名和电话！",
          type: "warning",
        });
        return;
      }
      addDemand(this.form).then(() => {
        this.$message({
          message: "提交成功",
          type: "success",
        });
        this.form = {
          name: undefined,
          companyName: undefined,
          phone: undefined,
          subMessage: undefined,
        };
      });
    },
    initMap() {
      AMapLoader.load({
        key: "a1ae5f9a20ef79daf95f3af159c157dd", //此处填入我们注册账号后获取的Key
        version: "1.4.8", //指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [""], //需要使用的的插件列表，如比例尺'AMap.Scale'等
      }).then((AMap) => {
        var map = new AMap.Map("map", {
          resizeEnable: true, //是否监控地图容器尺寸变化
          zoom: 16, //指定缩放级别
          center: [117.279522, 34.208544], //初始地图中心点
        });
        map.plugin(
          [
            "AMap.ToolBar",
            "AMap.Scale",
            "AMap.OverView",
            "AMap.MapType",
            "AMap.Geolocation",
          ],
          () => {
            // 在图面添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
            map.addControl(new AMap.ToolBar());

            // 在图面添加比例尺控件，展示地图在当前层级和纬度下的比例尺
            map.addControl(new AMap.Scale());

            // 在图面添加鹰眼控件，在地图右下角显示地图的缩略图
            // map.addControl(new AMap.OverView({
            // 	isOpen: true
            // }));

            // 在图面添加类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
            // map.addControl(new AMap.MapType());

            // // 在图面添加定位控件，用来获取和展示用户主机所在的经纬度位置
            // map.addControl(new AMap.Geolocation());
          }
        );
        // 实例化点标记
        let marker = new AMap.Marker({
          icon: this.marker,
          position: [117.279419, 34.208594],
          offset: new AMap.Pixel(-160, -100),
        });
        marker.setMap(map);
      });
    },
  },
};
</script>

<style scoped>
.map-section {
  display: flex;
  padding-bottom: 32px;
}
@media screen and (max-width: 1000px) {
  .map-section {
    flex-direction: column;
  padding-bottom: 0;
  }
}



@media screen and (max-width: 1000px) {
  .map-section .right {
    width: 100% !important;
    height: 540px !important;
    border-radius: 0px 0px 8px 8px !important;
    border: 1px solid #d9dbdf;
    background: linear-gradient(188deg, #d1d9ec 0%, #f8faff 100%);
    padding: 16px !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 32px;
  }
}

.map-section .right {
  width: 432px;
  height: 600px;
  border-radius: 0px 8px 8px 0px;
  border: 1px solid #d9dbdf;
  background: linear-gradient(188deg, #d1d9ec 0%, #f8faff 100%);
  padding: 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.map-section .right button {
  border-radius: 8px;
  background: #1cb3b8;
  border: none;
  font-size: 16px;
  text-align: center;
  line-height: 44px;
  font-weight: 500;
  color: #fff;
  box-sizing: border-box;
  cursor: pointer;
  width: 100%;
}

.map-section .right button:hover {
  transform: scale(1.01);
}

@media screen and (max-width: 1000px) {
  .map-section .left {
    flex: auto !important;
    width: 100% !important;
    height: 220px !important;
    border-radius: 8px 8px 0px 0px !important;
    border: 1px solid #d9dbdf;
    padding: 0 !important;
  }

  #map {
    border-radius: 8px 8px 0px 0px !important;
  }

  .map-section .left2::after,
  .map-section .left2::before,
  .map-section .left::before,
  .map-section .left::after {
    content: '' !important;
    width: 0px !important;
    height: 0px !important;
  }
}

.map-section .left {
  flex: 1;
  height: 600px;
  border-radius: 8px 0px 0px 8px;
  border: 1px solid #d9dbdf;
  background: #eff2f8;
  padding: 31px;
  position: relative;
}

.map-section .left::before {
  content: url("../../assets/map1.svg");
  width: 32px;
  height: 32px;
  display: block;
  position: absolute;
  left: 0;
  top: 0;
}

.map-section .left::after {
  content: url("../../assets/map2.svg");
  width: 32px;
  height: 32px;
  display: block;
  position: absolute;
  right: 0;
  top: 0;
}

#map {
  width: 100%;
  height: 100%;
}

.left2 {
  width: 100%;
  height: 100%;
}

.left2::before {
  content: url("../../assets/map3.svg");
  width: 32px;
  height: 32px;
  display: block;
  position: absolute;
  left: 0px;
  bottom: 0px;
}

.left2::after {
  content: url("../../assets/map4.svg");
  width: 32px;
  height: 32px;
  display: block;
  position: absolute;
  right: 0px;
  bottom: 0px;
}

#map {
  border: 1px solid #d9dbdf;
}
</style>
<style>
#map img {
  width: 356px;
}
</style>